import React from 'react';
import { ReactComponent as ConWxLogo } from './conwx_logo.svg';

export default props => {
    const { className } = props;
    return <ConWxLogo className={className} aria-label='ConWx Logo'/>
}